import createRoute   from '@widesk-ui/tools/createRoute';
import PlanningModel from '@models/website/PlanningModel';

const route = createRoute.dashboardFromModel(
	PlanningModel,
	'PlanningDashboard',
	{
		pathPrefix: '/website_entertainments/:websiteEntertainmentId',
	},
);
export default route;
